import { combineReducers } from 'redux';
import list from './list';
import del from './delete';
import show from './show';
import updateTags from './updateTags';
import access from './access';

export default combineReducers({ list, del, show, updateTags, access });
